import { useStoryblokApi } from "@storyblok/react";
import { Suspense, use, useMemo } from "react";
import { Link } from "react-router";
import { getEnvironmentVersion } from "../../../utils/getEnvironmentVersion";

export default function BlogOverview({blok}) {
  const storyblokApi = useStoryblokApi();
  const articlesPromise = useMemo(() => {
    return storyblokApi.getAll("cdn/stories", {
      version: getEnvironmentVersion(),
      starts_with: "blog",
      content_type: "blogpost",
    });
  }, [storyblokApi]);

  return (
    <section>
      <div className="container herosub">
        <h1>{blok.Title}</h1>
        <h2>{blok.Subheading}</h2>
      </div>
      
      <Suspense
        fallback={
          <div className="center">
            <span className="cat-loader"></span>
          </div>
        }
      >
        <div className="blog-posts-main-wrapper">
          <ul className="blog-posts-main-list">
            <ArticleList getArticles={articlesPromise} />
          </ul>
        </div>
      </Suspense>
    </section>
  );
}

export const ArticleList = ({ getArticles }) => {
  const articles = use(getArticles);

  return articles.map((article) => (
    <li key={article.uuid} className="blog-study-single">
      <div className="article-meta">
        <div className="image-wrap">
          <img src={article.content.featuredimage.filename} />
        </div>
        <h4>{article.name}</h4>
        <p>{article.content.summary}</p>
        <Link to={`/${article.full_slug}`} className="articlelink">
          {/* {article.name} */}Read more
        </Link>
      </div>
    </li>
  ));
};
